import React, { useState } from "react";
import Interval from "../../../../models/communications/Interval";
// import PathwayIcon from "./PathwayIcon";
import Stack from "@mui/material/Stack";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExistingInterval from "./ExistingInterval";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

export interface ExistingIntervalPreviewProps {
  fromIntervalSet: boolean;
  interval: Interval;
}

const ExistingIntervalPreview = (props: ExistingIntervalPreviewProps) => {
  const [expanded, setExpanded] = useState<string | false>(false);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };
  if (props.fromIntervalSet) {
    return (
      <Accordion
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography
            component="h2"
            variant="h6"
            sx={{ width: "33%", flexShrink: 0 }}
          >
            <AccessTimeIcon sx={{ fontSize: "14pt" }} /> &nbsp;
            {props.interval.name}
          </Typography>
          <Typography sx={{ color: "text.secondary" }}>
            <Stack direction="row">
              <span>
                <b>Start Day: </b>
                {props.interval.start_day}
              </span>
              <span>
                {" "}
                &nbsp;&nbsp; <b>End Day: </b>
                {props.interval.end_day}
              </span>
            </Stack>
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <ExistingInterval fromIntervalSet={true} interval={props.interval} />
        </AccordionDetails>
      </Accordion>
    );
  } else {
    return (
      <ExistingInterval fromIntervalSet={false} interval={props.interval} />
    );
  }
};

export default ExistingIntervalPreview;
